module.exports = __webpack_public_path__ + "static/media/performance-board.2b3b092d.svg";